import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function RecentCampaignCard({ campaign }) {
  const navigate = useNavigate()

  return (
    <div
      className='flex items-center bg-white dark:bg-rb-dark-mode gap-2 border border-rb-widget-boarder dark:border-rb-dark-mode-lighter rounded-md p-3 w-[200px] hover:cursor-pointer flex-shrink-0'
      onClick={() => navigate(`/project_manager/campaigns/${campaign.id}/overview`)}
    >
      <span className='h-7 w-7 rounded-lg text-sm flex items-center justify-center flex-shrink-0' style={{ backgroundColor: campaign.theme_color }}>
          <span className='text-white'>{campaign.name.slice(0, 2).toUpperCase()}</span>
      </span>
      <div className='min-w-0 flex-1'>
        <p className='text-xs rb-text-muted truncate'>{campaign.client_name}</p>
        <p className='text-sm font-bold dark:text-white truncate'>{campaign.name}</p>
      </div>
    </div>
  )
}
